import React from 'react';

import { BannerUI, AcceptMediaButton, Close } from './UI';

type ConfirmRecordProps = {
  onOk: () => void;
  onCancel: () => void;
  video: Blob | MediaSource;
}

const ConfirmRecord: React.FC<ConfirmRecordProps> = ({ video: videoFile, onOk, onCancel }) => {
  const url = React.useMemo(() => URL.createObjectURL(videoFile), [videoFile]);

  React.useEffect(() => () => URL.revokeObjectURL(url), [url]);

  return (
    <React.Fragment>
      <Close onClick={onCancel} />
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video autoPlay>
        <source src={url} type="video/mp4" />
      </video>

      <BannerUI small>
        <AcceptMediaButton
          type="primary"
          shape="circle"
          size="large"
          onClick={onOk}
          data-cy="camera-accept"
          icon={<span className="fb-icon--check" />}
        />
      </BannerUI>
    </React.Fragment>
  );
};

export default ConfirmRecord;
